// extracted by mini-css-extract-plugin
export default {"section":"YsCYW8Hdn1","section-head":"jvCSwJSRG6","sectionHead":"jvCSwJSRG6"};